import React from 'react';
import { createTooltipIcon } from '../utils/createTooltipIcon';

export const Vegetarian = createTooltipIcon(
  () => (
    <text x="50%" y="50%" textAnchor="middle" alignmentBaseline="central">
      V
    </text>
  ),
  '0 0 24 24'
);
